import { render, staticRenderFns } from "./TextareaField.vue?vue&type=template&id=ed9257d4"
import script from "./TextareaField.vue?vue&type=script&lang=ts"
export * from "./TextareaField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports